<template>
  <div class="myModal" ref="myModal">
    <el-dialog
      title="提示"
      :visible.sync="showState"
      :before-close="cancel"
      :close-on-click-modal='false'
      width="600px"
    >
      <span slot="title" class="fsize28">{{ title }}</span>
      <slot name="content"></slot>
      <slot name="footer"></slot>
      <span v-if="footer.slots == false" slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button class="blueBtn1" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    showState: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    footer: {
      type: Object,
      default() {
        return {
          footer: false,
          slots: false,
        };
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
